// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareButtons-module--container--13Cn7","button":"ShareButtons-module--button--1qeqa","icon":"ShareButtons-module--icon--O0LD3"};